export const initialContacts = [
  { id: 'id-1', name: 'Rosie Simpson', number: '459-12-56' },
  { id: 'id-2', name: 'Hermione Kline', number: '443-89-12' },
  { id: 'id-3', name: 'Eden Clements', number: '645-17-79' },
  { id: 'id-4', name: 'Annie Copeland', number: '227-91-26' },
  { id: 'id-5', name: 'Hesus Martinez', number: '447-91-26' },
  { id: 'id-6', name: 'Lino Sommerset', number: '227-88-26' },
  { id: 'id-7', name: 'Jeremy Breeze', number: '227-91-26' },
  { id: 'id-8', name: 'Axe Rodes', number: '459-33-56' },
  { id: 'id-9', name: 'Alex Rondo', number: '443-33-12' },
  { id: 'id-10', name: 'Gilbert Roys', number: '645-33-79' },
  { id: 'id-11', name: 'Manny Cole', number: '225-33-26' },
  { id: 'id-12', name: 'Hulio Pako', number: '445-44-26' },
  { id: 'id-13', name: 'Jerome Queen', number: '225-78-26' },
  { id: 'id-14', name: 'Simi Rose', number: '225-09-26' },
];
